const InvalidRuts = [
  "1-9",
  "2-7",
  "3-5",
  "4-3",
  "5-1",
  "6-K",
  "7-8",
  "8-6",
  "9-4",
  "10-8",
  
]

export default InvalidRuts;